import React from "react";
import {
  FaFileContract,
  FaCoins,
  FaProjectDiagram,
  FaCubes,
  FaImages,
} from "react-icons/fa";

function OurSmartConDev() {
  const reasons = [
    {
      icon: <FaFileContract size={20} />,
      title: "Custom Smart Contracts",
      desc: "We build smart contracts tailored to your business needs, ensuring functionality, security, and reliability. Our expertise spans across various blockchain platforms, including Ethereum, Binance Smart Chain, and more.",
    },
    {
      icon: <FaCoins size={20} />,
      title: "Token Development",
      desc: "Xeer Technology’s team creates standard and custom tokens (ERC-20, BEP-20, ERC-721) for a wide array of applications, enabling you to launch secure, compliant digital assets.",
    },
    {
      icon: <FaProjectDiagram size={20} />,
      title: "Smart Contract Integration",
      desc: "From integrating smart contracts with existing systems to developing DeFi protocols, we ensure smooth functionality and compatibility with your business ecosystem.",
    },
    {
      icon: <FaCubes size={20} />,
      title: "Decentralized Application (dApp) Development",
      desc: "Our team designs and deploys smart contracts to power dApps, enabling seamless user experiences, secure transactions, and decentralized interactions.",
    },
    {
      icon: <FaImages size={20} />,
      title: "DeFi & NFT Solutions",
      desc: "We specialize in creating DeFi protocols and NFT marketplaces, ensuring the security and scalability of these high-value, high-demand solutions.",
    },
  ];
  return (
    <>
      <div style={{ padding: "80px 0", background: "#fff" }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2
              className="fw-bold"
              style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}
            >
              Our Smart Contract Development Services
            </h2>
          </div>
          <div className="row g-4 justify-content-center">
            {reasons.map((item, idx) => (
              <div className="col-lg-4 col-md-6" key={idx}>
                <div className="ce-why-card">
                  <div className="ce-why-icon d-flex align-items-center justify-content-center">
                    {item.icon}
                  </div>
                  <div>
                    <h5
                      className="fw-bold mb-2"
                      style={{ color: "#0a1f44", fontSize: "17px" }}
                    >
                      {item.title}
                    </h5>
                    <p
                      className="mb-0 text-muted"
                      style={{ fontSize: "14px", lineHeight: "1.6" }}
                    >
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default OurSmartConDev;
